import "../../styles/all.css"
import "./card.css"
import { useTranslation } from "react-i18next";
function Cards(){
      const { t } = useTranslation();

    return(
        <>
        <div className="cards" data-aos = "fade-right">
  <div className="card active">
    <i className="fa-solid fa-people-group"></i>
    <h3>{t("team")}</h3>
    <p>
      {t("text_team")}
    </p>
  </div>

  <div className="card">
    <i className="fa-solid fa-code"></i>
    <h3>{t("web")}</h3>
    <p>
     {t("text_web")}
    </p>
  </div>

  <div className="card active">
    <i className="fa-solid fa-bullhorn"></i>
    <h3>{t("marketing")}</h3>
    <p>
     {t("text_marketing")}
    </p>
  </div>

  <div className="card">
    <i className="fa-solid fa-chart-line"></i>
    <h3>     {t("analsysis")}
</h3>
    <p>
     {t("text_analysis")}
    </p>
  </div>

  <div className="card active">
    <i className="fa-solid fa-shield-halved"></i>
    <h3>{t("cyber")}</h3>
    <p>
     {t("text_cyber")}
    </p>
  </div>

  <div className="card">
    <i className="fa-solid fa-cloud"></i>
    <h3>{t("cloud")}</h3>
    <p>
    {t("text_cloud")}
    </p>
  </div>
</div>

        </>
    )
}
export default  Cards